<div
  class="print-card-content-inflator-container"
  [style.padding.px]="data?.section | withContentBleed: preview"
  [style.height.px]="viewModel.contentHeight$ | async"
  [style.width.px]="viewModel.contentWidth$ | async"
  [style.transform]="viewModel.transform$ | async"
  [style.transform-origin]="viewModel.transformOrigin$ | async">
  <ng-template appInflatorContainer></ng-template>
</div>
